const UPLOADED_FILE_NAME = 'uploaded-file';

export const overrideFileName = ({ file, name = undefined }) => {
  if (!file) {
    return file;
  }

  return new File([file], name || UPLOADED_FILE_NAME, {
    type: file.type,
    lastModified: file.lastModified,
  });
};
